<template lang="pug" src="./childrens-ortho.pug"></template>

<script>
import Loader from 'components/loader/loader'
import HeroImage from 'components/hero/hero-image/hero-image'
import CustomChildrensWelcome from 'components/custom/custom-childrens-welcome/custom-childrens-welcome'
import CustomChildrensClub from 'components/custom/custom-childrens-club/custom-childrens-club'
import CustomChildrensQuestions from 'components/custom/custom-childrens-questions/custom-childrens-questions'

export default {
  computed: {
    props () {
      return this.$store.state.pages['childrens-ortho']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    HeroImage,
    CustomChildrensWelcome,
    CustomChildrensClub,
    CustomChildrensQuestions
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/childrens-ortho/childrens-ortho.vue